import { render, staticRenderFns } from "./ProfileEditor.vue?vue&type=template&id=0c3c2ac4&"
import script from "./ProfileEditor.vue?vue&type=script&lang=js&"
export * from "./ProfileEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports